<template>
	<textarea class="ap-comment" @keydown="keyboardHandler" v-model="comment"></textarea>
</template>

<script setup lang="ts">
import {ref, computed, watch} from "vue";
import {debounce} from "@/utils/Debounce.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";

const props = withDefaults(defineProps<{
	panelId: string,
	autosave?: boolean,
	comment?: string
}>(), { autosave: false, comment:"" });
const emit = defineEmits(["submit"]);
const ns = useNavigationStore();

const comment = ref<string>(props.comment);
const lastSaved = ref<string>(props.comment);

const dirty = computed<boolean>(() => comment.value !== lastSaved.value);

async function reallySaveComment(comment: string):Promise<boolean> {
	if (props.autosave) {
		const ok = await ns.savePanelComment(props.panelId, comment);
		if (ok) {
			lastSaved.value = comment;
		}
		return ok;
	} else return false;
}

const saveComment = debounce(reallySaveComment, 500);

watch(comment, () => {
	saveComment(comment.value);
});

function keyboardHandler(e:KeyboardEvent) {
	if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
		e.preventDefault();
		emit('submit');
	}
}

defineExpose({ dirty });
</script>

<style>

</style>